/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TopicWithArticlesResponsePage } from '../../models/topic-with-articles-response-page';

export interface ListTopics$Params {
  query?: string;
  enrichmentState?: string;
  publisherId?: Array<string>;
  periodId?: string;
  dataFilter?: string;
  articleLimit?: number;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'name' | '-name' | 'enrichmentState' | '-enrichmentState' | 'title' | '-title' | 'shortSummary' | '-shortSummary' | 'longSummary' | '-longSummary' | 'date' | '-date' | 'data' | '-data' | 'periodId' | '-periodId' | 'articlesCount' | '-articlesCount' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listTopics(http: HttpClient, rootUrl: string, params?: ListTopics$Params, context?: HttpContext): Observable<StrictHttpResponse<TopicWithArticlesResponsePage>> {
  const rb = new RequestBuilder(rootUrl, listTopics.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {"style":"form"});
    rb.query('enrichmentState', params.enrichmentState, {"style":"form"});
    rb.query('publisherId', params.publisherId, {"style":"form"});
    rb.query('periodId', params.periodId, {"style":"form"});
    rb.query('dataFilter', params.dataFilter, {"style":"form"});
    rb.query('articleLimit', params.articleLimit, {"style":"form"});
    rb.query('offset', params.offset, {"style":"form"});
    rb.query('limit', params.limit, {"style":"form"});
    rb.query('sorting', params.sorting, {"style":"form"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TopicWithArticlesResponsePage>;
    })
  );
}

listTopics.PATH = '/v0/topics';
